// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"95129832","284":"4f3cf07c","421":"0af9c80b","815":"29448575","857":"4018e79c","876":"2be01b2f","883":"8a2fa3e3","915":"2aeb6c11","959":"6fefac5c"}[chunkId] + ".chunk.js";
};